import camelCase from 'lodash/camelCase';
import React, { Fragment } from 'react';
import { Flex, Icon, Text } from '@qga/roo-ui/components';
import {
  ExclusiveInclusionsWrapper,
  ExclusiveInclusionSeparator,
  ExclusiveInclusion,
  ExclusiveInclusionTitle,
} from './ExclusiveInclusions.style';

const MAX_INCLUSIONS = 8;

interface ExclusiveInclusionsProps {
  inclusions: {
    code: string;
    name: string;
    subtitle?: string;
  }[];
}

const ExclusiveInclusions = ({ inclusions }: ExclusiveInclusionsProps) => {
  return (
    <ExclusiveInclusionsWrapper data-testid="exclusive-offer-inclusions">
      {inclusions.slice(0, MAX_INCLUSIONS).map((inclusion, i) => (
        <Fragment key={i}>
          <ExclusiveInclusion data-testid="exclusive-offer-inclusion">
            <ExclusiveInclusionTitle>
              <Icon name={camelCase(inclusion.code)} color="greys.steel" size={20} mt={1} />
              <Flex flexDirection="column">
                <Text fontSize="base" data-testid={`offer-inclusion-name-${i}`}>
                  {inclusion.name}
                </Text>
                <Text fontSize="sm" color="greys.steel" data-testid={`offer-inclusion-subtitle-${i}`}>
                  {inclusion?.subtitle}
                </Text>
              </Flex>
            </ExclusiveInclusionTitle>
          </ExclusiveInclusion>
          {i % 2 !== 0 && <ExclusiveInclusionSeparator />}
        </Fragment>
      ))}
    </ExclusiveInclusionsWrapper>
  );
};

export default ExclusiveInclusions;
